module.exports = __webpack_public_path__ + "img/category-Science fiction.3de6fbb1.svg";